import {teachers, staffs} from './db.js';

export function isTeacher(personId) {
  return teachers[personId] !== undefined;
}

export function isStaff(personId) {
  return staffs[personId] !== undefined;
}
